module.exports = __webpack_public_path__ + "static/media/replyIcon.52837c41.svg";